import {
  adjustmentPeriodFlag,
  endDateColumnDefinition,
  periodColumnDefinition,
  periodNumberColumnDefinition,
  periodYearColumnDefinition,
  quarterNumberColumnDefinition,
  quarterStartDateColumnDefinition,
  startDateColumnDefinition,
  yearStartDateColumnDefinition,
} from '../columnDefinitions';


const periodsColumnDefinitions = [
  periodColumnDefinition,
  endDateColumnDefinition,
  startDateColumnDefinition,
  yearStartDateColumnDefinition,
  quarterStartDateColumnDefinition,
  periodYearColumnDefinition,
  periodNumberColumnDefinition,
  quarterNumberColumnDefinition,
  adjustmentPeriodFlag,
];

export default periodsColumnDefinitions;
